import { render } from "./gmap-custom-marker.vue?vue&type=template&id=429bdefb"
import script from "./gmap-custom-marker.vue?vue&type=script&lang=js"
export * from "./gmap-custom-marker.vue?vue&type=script&lang=js"
script.render = render

export default script